import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { IAppConfig } from './model/app-config.model';
@Injectable()
export class AppConfig {
	static settings: IAppConfig;
	constructor(private http: HttpClient) { }
	load() {
		const jsonFile = `assets/config/config.${environment.name}.json`;
		return new Promise<void>((resolve, reject) => {
			this.http.get(jsonFile).toPromise().then((response: IAppConfig) => {
				AppConfig.settings = <IAppConfig>response;
				resolve();
			}).catch((response: any) => {
				reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
			});
		});
	}

	public static appSetting(key: string): string {
		return AppConfig.settings.appSettings[key];
	}

	public static appSettingConcat(keys: string[]) :string {
        return keys.reduce(this.concat, "")
	}

  static concat(accumulator: string, key: string) {
		return accumulator.concat(AppConfig.settings.appSettings[key]);
	}
}
